<template>
	<div class="text-white skeleton-loader">
		<div class="grid items-center justify-center grid-cols-4 gap-x-6 gap-y-6">
			<div
				class="flex flex-col justify-between h-32 px-5 py-4 rounded-lg custum-bg-opacity-40"
				v-for="(item, index) in new Array(4)"
				:key="index"
			>
				<div class="flex flex-row items-end justify-start space-x-1"></div>
				<div class="flex flex-row items-center space-x-3 text-lg">
					<p class="text-bold opacity-60"></p>
					<div class="flex items-center space-x-1"></div>
				</div>
			</div>
		</div>
		<div class="flex flex-row mt-5 space-x-4 h-[calc(100vh-24rem)]">
			<div class="flex flex-col w-2/3 p-4 rounded-lg custum-bg-opacity-40">
				<div class="mb-6 text-bold opacity-60"></div>
				<div class="flex flex-col items-start justify-center w-full h-full"></div>
			</div>
			<div class="flex flex-col w-1/3 p-4 rounded-lg custum-bg-opacity-40">
				<div class="mb-6 text-bold opacity-60"></div>
				<div class="flex justify-between h-full"></div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.custum-bg-opacity-40 {
		background-color: rgba(112, 11, 102, 0.4);
	}
</style>
